import React, { useContext } from 'react';

import { LanguageContext } from '../contexts/LanguageProvider';
import { LANGUAGES } from '../constant/languages';

const Description: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const descriptionText = language === LANGUAGES.JA
    ? `「民族文化生物学研究会」は、各地域の文化と生物資源の多様な関係を発信します。
    文化は衣食住や習俗、歴史を含み、生物資源は動植物や菌類など多岐にわたります。
    私たちは、地域文化の多様性を明らかにし、生物資源の新たな活用と共生のあり方を探ります。`
    : `The Society for Ethno-Cultural Biology explores the diverse connections between cultures and biological resources.
      Culture includes food, clothing, housing, customs, and history, while biological resources cover animals, plants, and fungi.
      We study cultural diversity and explore new ways to use and coexist with biological resources.`;

  return (
    <>
      <div className="mt-10 p-4 bg-green-100 border-l-4 border-green-500 rounded-lg">
        <p className="text-base sm:text-lg text-gray-700 text-center" style={{ whiteSpace: 'pre-wrap' }}>
          {descriptionText}
        </p>
      </div>
    </>
  );
};

export default Description;
